import d from "toastify-js";
import { t as l } from "./index-5de47637.mjs";
const p = "off", f = "polite", m = "assertive";
var r = ((t) => (t[t.OFF = p] = "OFF", t[t.POLITE = f] = "POLITE", t[t.ASSERTIVE = m] = "ASSERTIVE", t))(r || {});
const T = 1e4, v = 7e3, L = -1;
function c(t, o) {
  var s;
  if (o = Object.assign({ timeout: v, isHTML: !1, type: void 0, selector: void 0, onRemove: () => {
  }, onClick: void 0, close: !0 }, o), typeof t == "string" && !o.isHTML) {
    const u = document.createElement("div");
    u.innerHTML = t, t = u.innerText;
  }
  let n = (s = o.type) != null ? s : "";
  typeof o.onClick == "function" && (n += " toast-with-click ");
  const a = t instanceof Node;
  let e = r.POLITE;
  o.ariaLive ? e = o.ariaLive : (o.type === "toast-error" || o.type === "toast-undo") && (e = r.ASSERTIVE);
  const i = d({ [a ? "node" : "text"]: t, duration: o.timeout, callback: o.onRemove, onClick: o.onClick, close: o.close, gravity: "top", selector: o.selector, position: "right", backgroundColor: "", className: "dialogs " + n, escapeMarkup: !o.isHTML, ariaLive: e });
  return i.showToast(), i;
}
function g(t, o) {
  return c(t, { ...o, type: "toast-error" });
}
function h(t, o) {
  return c(t, { ...o, type: "toast-warning" });
}
function k(t, o) {
  return c(t, { ...o, type: "toast-info" });
}
function O(t, o) {
  return c(t, { ...o, type: "toast-success" });
}
function b(t, o, s) {
  if (!(o instanceof Function))
    throw new Error("Please provide a valid onUndo method");
  let n;
  s = Object.assign(s || {}, { timeout: T, close: !1 });
  const a = document.createElement("span"), e = document.createElement("button");
  return a.classList.add("toast-undo-container"), e.classList.add("toast-undo-button"), e.innerText = l("Undo"), a.innerText = t, a.appendChild(e), e.addEventListener("click", function(i) {
    i.stopPropagation(), o(i), (n == null ? void 0 : n.hideToast) instanceof Function && n.hideToast();
  }), n = c(a, { ...s, type: "toast-undo" }), n;
}
export {
  T,
  v as a,
  L as b,
  p as c,
  f as d,
  m as e,
  O as f,
  h as g,
  k as h,
  g as i,
  b as j,
  c as s
};
